import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';

export interface DeleteClipDialogProps {
  open: boolean;
  clipName: string;
  deleting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

export const DeleteClipDialog: React.FC<DeleteClipDialogProps> = ({
  open,
  clipName,
  deleting,
  onCancel,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="xs"
      fullWidth
      slotProps={{ paper: { sx: { borderRadius: '12px' } } }}
    >
      <DialogTitle sx={{ fontFamily: '"Space Grotesk"', fontWeight: 500 }}>
        Delete {clipName}?
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          Are you sure? This can&apos;t be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onCancel} disabled={deleting} color="inherit">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={deleting}
        >
          Delete Clip
        </Button>
      </DialogActions>
    </Dialog>
  );
};
